import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { InputCard } from "components/InputCards/InputCard";
import React from "react";
import { useResultingListForm } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/providers/ResultingListFormContextProvider";

import cx from "classnames";

export const ProductSuggestionTargetProperties = () => {
  const { product } = useProductConfiguratorStore.use.productData() || {};
  const { values, setValue } = useResultingListForm();

  if (!product?.listViewConfiguration?.targetProperties) {
    return null;
  }

  return (
    <div className="mt-4 border-top pt-4">
      {product?.listViewConfiguration.targetPropertiesTitle && (
        <h5 className="mb-2 font16">
          {product?.listViewConfiguration.targetPropertiesTitle}
        </h5>
      )}
      <div className="row">
        {product?.listViewConfiguration?.targetProperties?.map(
          (
            { name, id, valueMax, valueMin, defaultValue, unit },
            index: number,
          ) => (
            <div
              key={id}
              className={cx("col-12 col-lg-6", {
                "border-lg-end": index % 2 === 0,
              })}
            >
              <InputCard
                key={id}
                label={name}
                defaultValue={defaultValue}
                value={values[id] ?? defaultValue}
                displayValue={defaultValue}
                valueMin={valueMin}
                valueMax={valueMax}
                unit={unit}
                isValueEditable={true}
                onChange={(val: string | number) => setValue(id, val)}
                testId={`${id}`}
                subLabel={
                  valueMin && valueMax && `${valueMin}..${valueMax} ${unit}`
                }
                validationMessage={undefined}
                validationType={undefined}
              />
            </div>
          ),
        )}
      </div>
    </div>
  );
};
